export default __webpack_public_path__ + "f824744717d31b68c3e365abd950f15c.png";